export default __webpack_public_path__ + "static/media/flag8.fb23cd9d.jpg";